import { AlertTriangle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const ReleaseConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Release',
  description = 'This action cannot be reversed.',
  details = [],
  loading = false,
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            {title}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {details.length > 0 && (
          <div className="space-y-2 py-2">
            {details.map(({ label, value }) => (
              <div key={label} className="flex justify-between text-sm">
                <span className="font-medium text-muted-foreground">{label}</span>
                <span className="text-right">{value}</span>
              </div>
            ))}
          </div>
        )}
        <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
          This action is permanent and cannot be undone. The linked items will be moved to the Master List.
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? 'Releasing...' : 'Confirm Release'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReleaseConfirmDialog;
